export default __webpack_public_path__ + "static/media/solutionsIcon.2dd647f2.svg";